/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-08 10:21:02
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  sourceFile: '来源文件',
  fileName: '文件名称',
  queryFile: '查询文件',
  state: '状态',
  uploader: '上传人',
  uploadDate: '上传日期',
  objectRegistrationRecord: '对象注册记录',
  category: '类别',
  queryTagCodeOrTagName: '查询位号编码或位号名称',
  objectEncoding: '对象编码',
  objectName: '对象名称',
  superior: '上级',
  describe: '描述',
  pleaseSelectTheSourceFileFirst: '请先选择来源文件',
}
